import { isNullOrUndefined } from './typeChecks.js';
export function isArrayLike(obj) {
    return Array.isArray(obj) || isObservableArray(obj);
}
export function isObservableArray(obj) {
    return (typeof obj !== 'string' &&
        !isNullOrUndefined(obj) &&
        !isNullOrUndefined(obj.length) &&
        !isNullOrUndefined(obj.slice) &&
        typeof obj.slice === 'function');
}
//# sourceMappingURL=isArrayLike.js.map